var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card-edit',{on:{"edit":function($event){return _vm.$emit('edit')}}},[_c('order-payment',{attrs:{"order":_vm.$store.getters.orderSystem.order,"total-amount":_vm.$store.getters.orderSystem.cartService.getTotalAmountWithDiscount,"divider":"","flat":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }